import { withNamespaces } from 'react-i18next';
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Spinner,
    UncontrolledDropdown,
} from 'reactstrap';

import {
    getAvailableMailboxIntents,
    isStarredMessage,
    isTrashFolderMessage,
} from '../../../helpers';

const MessageActions = ({
    t,
    message,
    intents = [],
    cases = [],
    isActing = false,
    onTrash,
    onRestore,
    onToggleStar,
    onApplyIntent,
}) => {
    const isTrash = isTrashFolderMessage(message);
    const starred = isStarredMessage(message);
    const availableIntents = getAvailableMailboxIntents(intents, message, cases);

    return (
        <div className="mailbox-message-detail__actions">
            {availableIntents.length ? (
                <UncontrolledDropdown>
                    <DropdownToggle
                        tag="button"
                        type="button"
                        className="btn btn-primary mailbox-message-detail__add"
                        disabled={isActing}
                        title={t('Add to Incident or Request')}
                    >
                        {isActing ? (
                            <Spinner size="sm" />
                        ) : (
                            <i className="mdi mdi-plus" />
                        )}
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                        {availableIntents.map((item) => (
                            <DropdownItem
                                key={item.code}
                                disabled={isActing}
                                onClick={() => onApplyIntent(item.code)}
                            >
                                <i className="mdi mdi-plus me-1" />
                                {t(item.addKey)}
                            </DropdownItem>
                        ))}
                    </DropdownMenu>
                </UncontrolledDropdown>
            ) : null}

            <UncontrolledDropdown>
                <DropdownToggle
                    tag="button"
                    type="button"
                    caret={false}
                    className="btn mailbox-message-detail__more"
                    disabled={isActing}
                    title={t('More')}
                >
                    <i className="mdi mdi-dots-vertical" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem
                        disabled={isActing}
                        onClick={() => onToggleStar?.(!starred)}
                    >
                        <i className={`mdi ${starred ? 'mdi-star' : 'mdi-star-outline'} text-primary me-2`} />
                        {starred ? t('Mark as unstarred') : t('Mark as starred')}
                    </DropdownItem>
                    {isTrash ? (
                        <DropdownItem
                            disabled={isActing}
                            onClick={onRestore}
                        >
                            <i className="mdi mdi-delete-restore text-primary me-2" />
                            {t('Restore')}
                        </DropdownItem>
                    ) : (
                        <DropdownItem
                            disabled={isActing}
                            onClick={onTrash}
                        >
                            <i className="mdi mdi-delete-outline text-primary me-2" />
                            {t('Move to Trash')}
                        </DropdownItem>
                    )}
                </DropdownMenu>
            </UncontrolledDropdown>
        </div>
    );
};

export default withNamespaces()(MessageActions);
